import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import { CreateCustomerPortalSessionResponseDataSchema, DataResponse } from "schema"
import { z } from "zod"

type Response = DataResponse<z.infer<typeof CreateCustomerPortalSessionResponseDataSchema>>
type OnSuccessFn = (data: Response) => void

type Props = {
  onSuccess?: OnSuccessFn
}

const getBillingPortalQueryKey = () => ["billing-portal"]

export const billingPortalQuery = ({ onSuccess }: Props = {}) => {
  return queryOptions({
    queryKey: getBillingPortalQueryKey(),
    queryFn: async () => {
      const { data } = await axios.get<Response>("/billing/customer-portal")
      onSuccess?.(data)
      return data.data.url
    },
  })
}
